import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsCategoryHighlightBlock_Box_1 = styled.div`
  margin: ${-gutterWidth / 4}px;
  display: flex;
  flex-wrap: wrap;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin: ${-gutterWidth / 2}px;
  }
`;

export const CmsCategoryHighlightBlock_Box_2 = styled.div`
  text-align: left;
  margin-bottom: ${gutterWidth / 2}px;

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    text-align: center;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-bottom: ${gutterWidth * 1.5}px;
  }
`;
